export const IconFile2 = (props: { size?: number }) => {
	const width: number = props.size ?? 24;
	return (
		<svg width={width} height={width} viewBox={`0 -960 960 960`} fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill="#999999"
				d="M252.31-100Q222-100 201-121q-21-21-21-51.31v-615.38Q180-818 201-839q21-21 51.31-21H570l210 210v477.69Q780-142 759-121q-21 21-51.31 21H252.31ZM540-620h180L540-800v180Z"
			/>
		</svg>
	);
};
